import { useMyTranslations } from '@hooks/useMyTranslations';
import BrandForm from '@forms/BrandForm';
import { BrandsTransFields } from '@pages/Brands/types';
import { brandsTranslations } from '@pages/Brands/translations';
import { PageHeader } from '@/components/Core/PageHeader';

function AddBrand() {
  const { t } = useMyTranslations<Extract<BrandsTransFields, 'addBrand'>>([
    brandsTranslations.name,
  ]);

  return (
    <div className="page-container">
      <PageHeader text={t('addBrand')} />
      <BrandForm />
    </div>
  );
}

export default AddBrand;
